export const RESERVATION_CONST = {
    GET_CALL_DATA:"GET_CALL_DATA",
    DELETE_CALL_DATA:"DELETE_CALL_DATA",
}